import React, { Component } from "react";
import { Image } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { Suspense, lazy } from "react";
import {
  USER_DATA,
  SELECTED_HOTEL_ID,
  SELECTED_HOTEL_NAME,
} from "../../../constants";
import { logout } from "../../../redux/actions/user_actions";
import { clearSession } from "../../../redux/actions/session_actions";
import { connect } from "react-redux";
import { isMobile } from "react-device-detect";
import * as Constants from "../../../constants";
import newExtranetImages from "../../../assets";
import CustomDropdown from "./CustomDropdown/CustomDropdown";
import SideNavbar from "./SideNavbar";
import Auth from "../../../hoc/auth";
import HeaderComponentWeb from "./headerComponentWeb";

const HeaderComponentMobile = React.lazy(() =>
  import("./headerComponent_m")
);

class Header extends Component {
  state = {
    activeItem: "/bookings",
    visible: false,
    label: "My Bookings",
    icon: "calendar alternate",
    financeMenuVisible: false,
    userType: "",
    isAdminAvailable: false,
    inputValue: "",
    //NEW
    isShowMenu: false,
    isShowMenuHover: false,
    isNewBookings: false,
    isDropdownOpen: false,
    down: false,
    up: true,
  };

  onChangeDropdown = (value) => {
    this.setState({ inputValue: value });
  };

  getMenuList = () => {
    let unlistedClosedLabel = "";
    let permissions = this.props.session.data.permissions;
    let isRateForUser =
      this.props.session.data.permissions.uep_user_rate_access !== "na";
    let isSuperAdmin =
      this.props.session.data.user_access_type === "SUPER_ADMIN";
    let isAdmin = this.props.session.data.user_access_type === "ADMIN";
    let menuList = [];
    let subMenulist = [];
    let isHotelClosed = 0;
    if (
      permissions.uep_hotel_listing == 1 &&
      permissions.uep_closed_hotels == 1
    ) {
      unlistedClosedLabel = ["Unlisted/Closed Hotels"];
      isHotelClosed = 1;
    } else if (
      permissions.uep_hotel_listing == 1 &&
      permissions.uep_closed_hotels == 0
    ) {
      unlistedClosedLabel = "Unlisted Hotels";
    } else if (
      permissions.uep_hotel_listing == 0 &&
      permissions.uep_closed_hotels == 1
    ) {
      unlistedClosedLabel = "Closed Hotels";
    }
    if (permissions.uep_view_bookings == "1") {
      menuList.push({
        label: "Bookings",
        pathValue: "/bookings",
        icon: "calendar alternate",
        type: "non-admin",
        isAvailableForUser: true,
      });
    }

    if (isRateForUser || permissions.uep_inventories == "1") {
      menuList.push({
        label: "Manage Rates / Rooms",
        pathValue: "/inventory",
        icon: "building",
        type: "non-admin",
        isAvailableForUser: isRateForUser,
      });
    }
    if (permissions.uep_amenities == "1") {
      menuList.push({
        label: "Amenities",
        pathValue: "/amenities",
        icon: "bed",
        type: "non-admin",
        isAvailableForUser: true,
      });
    }
    menuList.push({
      label: "Policy Updates",
      pathValue: "/policy",
      icon: "file alternate",
      type: "non-admin",
      isAvailableForUser: true,
    });
    if (permissions.uep_finance == "1") {
      menuList.push({
        label: "Hotel Finance",
        pathValue: "/hotel-finance",
        icon: "money bill alternate",
        type: "non-admin",
        isAvailableForUser: true,
      });
    }
    if (permissions.uep_add_manager == "1") {
      menuList.push({
        label: "User Access",
        pathValue: "/user-access",
        icon: "user circle",
        type: "non-admin",
        isAvailableForUser: true,
      });
    }
    if (permissions.uep_hotel_profile == "1") {
      menuList.push({
        label: "Profile",
        pathValue: "/profile",
        icon: "user",
        type: "non-admin",
        isAvailableForUser: true,
      });
    }
    if (isSuperAdmin) {
      menuList.push({
        label: "Go to Admin",
        pathValue: "/admin",
        icon: "long arrow alternate right",
        color: "#3377ab",
        type: "admin",
        isAvailableForUser: true,
        subMenulist: subMenulist,
      });
    }

    return menuList;
  };

  handleDropdown = () => {
    console.log("clicked");
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
    this.setState({ inputValue: "" });
  };

  handleMenu = () => {
    console.log(this.isShowMenu);
    this.setState({ isShowMenu: !this.state.isShowMenu });
  };

  handleItemClick = (e, { name, label, value, type }) => {
    if (name == "/admin") {
      window.open(Constants.ADMINCHECKOUT, "_blank");
    } else {
      this.setState({ visible: false });
      this.setState({ activeItem: name });
      this.setState({ label: label });
      this.setState({ icon: value });
      // this.setState({ userType: type })
      this.props.history.push(name);
    }
  };

  handleChangedValue = (event, valueSet) => {
    let userData = JSON.parse(localStorage.getItem(USER_DATA));
    let selectedHotel = userData.hotels.find(
      (hotel) => hotel.hotel_id === valueSet.value
    );
    localStorage.setItem(SELECTED_HOTEL_ID, selectedHotel.hotel_id);
    localStorage.setItem(SELECTED_HOTEL_NAME, selectedHotel.hotel_name);
    if (selectedHotel?.agreement_type === "DISPLAY") {
      this.props.history.push("/agreement");
    } else if (
      selectedHotel?.agreement_type !== "DISPLAY" &&
      selectedHotel?.allow_foreign_guest === "DISPLAY"
    ) {
      this.props.history.push("/foreign-guest");
    } else {
      this.props.history.push("/redirect");

      if (isMobile) {
        setTimeout(() => {
          this.props.history.push("/summary");
        }, 2);
      } else {
        setTimeout(() => {
          //NEW
          // this.props.history.push("/");
          this.props.history.push("/bookings");
          this.setState({ isNewBookings: true });
          //

          // this.props.history.push("/bookings");
        }, 2);
      }

      this.setState({
        activeItem: this.getMenuList()[0].pathValue,
        label: this.getMenuList()[0].label,
        icon: this.getMenuList()[0].icon,
      });
    }
  };

  logoutUser = () => {
    this.setState({ isShowMenu: false });
    let userData = JSON.parse(localStorage.getItem(USER_DATA));
    let data = {
      login_user_id: userData.login_user_id,
      login_user_name: userData.login_user_name,
      login_user_type: userData.user_access_type,
      product: "EXTRANET"
    };
    this.props.dispatch(logout(data));
    this.props.dispatch(clearSession());
    this.props.history.push("/login");
  };

  isUserHeader = () => {
    let userData = JSON.parse(localStorage.getItem(USER_DATA));
    return userData && userData.token && userData.token.length > 20;
  };

  getHotelList = () => {
    // Prefer the live auth response from redux so newly linked hotels appear
    // immediately; localStorage is only the fallback before the session loads.
    let userData =
      this.props.session && this.props.session.data && this.props.session.data.hotels
        ? this.props.session.data
        : JSON.parse(localStorage.getItem(USER_DATA));
    return userData.hotels.map((hotel) => ({
      value: hotel.hotel_id,
      text: hotel.hotel_name,
      key: hotel.hotel_name,
      content: isMobile ? (
        <div style={{ fontSize: "16px", fontWeight: "500" }}>
          {hotel.hotel_name}
        </div>
      ) : (
        <div>{hotel.hotel_name}</div>
      ),
    }));
  };

  sidebarOpenClick = () => {
    this.setState({ visible: !this.state.visible });
  };

  sidebarCloseClick = () => {
    this.setState({ visible: false });
  };

  changePassword = () => {
    this.props.history.push("/password-change");
  };

  changePasswordNew = () => {
    this.setState({ isShowMenu: false });
    this.props.history.push("/password-change");
  };

  //NEW
  handleHover2 = (e) => {
    this.setState({ isShowMenuHover: false });
    this.setState({ isShowMenu: false });
  };

  handleHover = (e, type) => {
    if (type == "in") {
      e.target.style.backgroundColor = "#F6F3FA";
    } else if (type == "out") {
      e.target.style.backgroundColor = "";
    }
  };
  //

  onNavigateToOldUI = () => {
    this.props.history.push("/bookings");
    this.setState({ isShowMenu: false });
  };

  setActiveItem = (item) => {
    this.setState({
      activeItem: item,
    });
  };

  getMenuListFinance = () => {
    let menuList = [];
    menuList.push(
      {
        label: "Ledger",
        name: "Ledger",
        color: "white",
        pathValue: "/finance/ledger",
        key: "Ledger",
        icon: "calendar alternate",
      },
      {
        label: "Hotel Balance List",
        name: "Hotel Balance List",
        pathValue: "/finance/hotel-balance-list",
        color: "white",
        key: "hotelFinance",
        icon: "calendar alternate",
      },
      {
        label: "Invoice Generation",
        name: "Invoice Generation",
        pathValue: "/finance/invoice-generation",
        color: "white",
        key: "Cr/Dr",
        icon: "calendar alternate",
      }
    );
    return menuList;
  };

  upDownHover = (e, type) => {
    if (type == "enter") {
      e.target.style.height = "2rem";
    } else {
      e.target.style.height = "1.5rem";
    }
  };

  financeSidebarAction = () => {
    this.setState({ financeMenuVisible: !this.state.financeMenuVisible });
  };

  render() {
    const { activeItem } = this.state;

    return (
      <>
        {/* {Constants.debug == 0 ? (
          <></>
        ) : (
          <div
            style={{
              fontSize: "1.5em",
              fontWeight: "bold",
              textAlign: "center",
              backgroundColor: "#fff",
            }}
          >
            {Constants.debug == 6 ? "Adex" : "Test"}
          </div>
        )} */}

        {this.props.session && this.props.session.isSessionValid ? (
          isMobile ? (
            this.props.location.pathname === "/create-room-category" ||
            this.props.location.pathname.includes("/room-category") ||
            this.props.location.pathname.includes("/rate-plan") ||
            this.props.location.pathname === "/internal-server-error" ? null : (
              <div>
                <Suspense fallback>
                  <HeaderComponentMobile
                    logoutUser={this.logoutUser}
                    changePassword={this.changePassword}
                    getHotelList={this.getHotelList}
                    getMenuList={this.getMenuList}
                    handleItemClick={this.handleItemClick}
                    handleChangedValue={this.handleChangedValue}
                    sidebarOpenClick={this.sidebarOpenClick}
                    sidebarCloseClick={this.sidebarCloseClick}
                    state={this.state}
                    hideHeader={this.props.hideHeader}
                    hotelList={JSON.parse(localStorage.getItem(USER_DATA))}
                    {...this.props}
                  />
                </Suspense>
              </div>
            )
          ) : (
            <HeaderComponentWeb {...this.props} />
          )
        ) : isMobile ? (
          <div
            style={{
              backgroundColor: "#5F1CCC",
              width: "100vw",
              height: "4.5rem",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed", 
              zIndex: 2, 
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="135"
              height="29"
              viewBox="0 0 135 29"
              fill="none"
            >
              <path
                d="M2.44111 15.9341C1.84914 15.7391 1.44636 15.4812 1.00696 15.022C0.305139 14.2923 0 13.5374 0 12.5309C0 11.537 0.317345 10.7569 1.00696 10.0461C2.07495 8.94525 3.60064 8.69362 5.00428 9.39817C5.52302 9.65609 6.20043 10.3418 6.46285 10.8765L6.65204 11.2728L5.81595 11.7068C5.35214 11.9522 5.00428 12.1472 5.0348 12.1472C5.07141 12.1472 5.4742 12.0528 5.93191 11.9396C6.87784 11.7068 6.7985 11.6754 6.86563 12.2793C6.93887 12.9272 6.72527 13.8079 6.34079 14.4181C5.88309 15.1541 5.22398 15.6699 4.43062 15.9216C3.88747 16.0914 2.93544 16.0977 2.44111 15.9341ZM3.63116 14.6571C4.24144 14.4936 4.63812 14.2923 4.84561 14.0407C5.0409 13.7953 5.08972 13.6192 5.05311 13.2166C5.01649 12.8391 4.87002 12.6127 4.52216 12.4114C4.32687 12.3044 4.27195 12.2415 4.30857 12.1598C4.40621 11.9144 4.40621 11.4489 4.30246 11.1784C4.07666 10.5682 3.65557 10.3669 2.91103 10.5179C2.53266 10.5934 1.78812 10.8639 1.68437 10.9645C1.64165 11.0023 1.86745 11.7005 1.98341 11.883C1.98951 11.8956 2.1909 11.8452 2.42891 11.776C2.97206 11.6188 3.15514 11.6188 3.22837 11.7697C3.31992 11.9459 3.19176 12.0654 2.79508 12.1849C2.59979 12.2415 2.44111 12.317 2.44111 12.3611C2.44111 12.4177 2.6303 13.1663 2.65471 13.204C2.65471 13.2103 2.80728 13.1788 2.99036 13.1285C3.43587 13.0027 3.58233 13.009 3.65557 13.1537C3.75932 13.3487 3.60675 13.4682 3.0575 13.6318C2.77677 13.7198 2.53876 13.7953 2.52655 13.8016C2.51435 13.8205 2.60589 14.4873 2.65471 14.7138C2.69133 14.8773 2.83169 14.8647 3.63116 14.6571Z"
                fill="white"
              />
              <path
                d="M8.46412 15.0724C7.92707 14.9717 6.83468 14.6194 6.83468 14.5439C6.83468 14.5188 6.90181 14.3426 6.98725 14.1476C7.40834 13.1977 7.42054 11.9522 7.01166 10.9709L6.8957 10.6941L7.40834 10.7129L7.92097 10.7381L7.95759 10.4865C8.13457 9.21577 8.53735 4.13924 8.46412 4.06375C8.36647 3.9631 7.20695 3.8939 6.59056 3.95052L5.94977 4.00713L5.90705 4.25876C5.88874 4.39715 5.85213 4.75572 5.82772 5.06396L5.77889 5.61124H5.98029C6.15727 5.61124 6.16947 5.62382 6.13896 5.78738C6.12065 5.88174 6.06572 6.47935 6.0108 7.12099C5.96198 7.76264 5.89485 8.5301 5.87043 8.82576L5.82772 9.37304L5.43714 9.12771C4.74142 8.69365 4.36915 8.59929 3.34388 8.59929H2.45287L2.41015 8.03314C2.32472 6.82534 2.62375 5.35333 3.19131 4.19585C3.85652 2.83078 5.1381 1.51604 6.49902 0.811491C7.25577 0.421472 8.32376 0.125813 9.28189 0.0377438L9.75181 0L9.78842 0.773748C9.80673 1.20151 9.84335 2.03816 9.86166 2.62319C9.88607 3.21451 9.91048 3.66744 9.92269 3.62969C9.93489 3.59824 10.1058 2.78675 10.3133 1.83686C10.5208 0.886979 10.6916 0.10065 10.7038 0.0880688C10.716 0.0817782 10.9419 0.119522 11.2043 0.169847C13.2853 0.610191 15.0368 1.87461 16.1109 3.71776C16.4161 4.25247 16.7578 5.03251 16.8188 5.35962C16.8555 5.54205 16.8493 5.54834 16.6358 5.54834C16.233 5.54834 15.6044 5.74335 14.9636 6.06417C13.8346 6.63033 12.9131 7.70602 12.5103 8.91383C12.4553 9.08367 12.3821 9.22836 12.3516 9.22836C12.3211 9.22207 12.0159 9.20319 11.6742 9.17174C11.1249 9.12771 11.0456 9.10883 11.0456 9.00189C11.0456 8.7943 11.3141 8.58042 11.9244 8.30992C12.6384 7.99539 12.9436 7.76893 13.2182 7.35375C13.4684 6.97631 13.5599 6.65549 13.5599 6.11449C13.566 5.56092 13.4623 5.20864 13.206 4.91927C12.9375 4.61103 12.614 4.45377 11.9915 4.31537C11.4667 4.20214 10.1729 4.1644 9.69078 4.24618L9.41005 4.2965L9.44057 5.15832C9.45277 5.63012 9.47718 6.05159 9.48939 6.09562C9.5077 6.14595 9.60534 6.13337 9.83725 6.03901C10.2461 5.87545 11.186 5.81883 11.4057 5.93836C11.8512 6.18369 11.7047 6.38499 10.8137 6.73727C9.69688 7.17132 9.20256 7.63054 8.97065 8.42945C8.8486 8.8635 8.69603 10.7004 8.77536 10.7821C8.82418 10.8325 10.7832 11.0652 11.6437 11.1218L12.2478 11.1659L12.3821 11.7069C12.5408 12.3863 12.8886 13.1348 13.2914 13.6633C13.4623 13.8834 13.5905 14.0847 13.5722 14.1099C13.5233 14.198 12.5225 14.6635 12.0648 14.8207C11.8023 14.9088 11.3507 15.022 11.0578 15.0786C10.3987 15.1982 9.11101 15.1919 8.46412 15.0724Z"
                fill="white"
              />
              <path
                d="M16.5318 15.1038C15.5675 14.9717 14.6338 14.4621 13.9198 13.6884C13.4011 13.1285 13.0898 12.5812 12.864 11.8389C12.7481 11.4426 12.7236 11.235 12.7236 10.5179C12.7298 9.73157 12.742 9.63092 12.9189 9.11509C13.5841 7.18387 15.2075 5.98865 17.1604 5.98865C17.9293 5.98865 18.4603 6.12075 19.156 6.46674C19.6503 6.71836 19.8212 6.84417 20.2911 7.33484C21.1699 8.24069 21.53 9.08364 21.5849 10.3355C21.6276 11.2099 21.5239 11.776 21.2065 12.4617C20.7976 13.3361 20.3277 13.896 19.5649 14.4118C19.1682 14.676 18.3382 15.0409 18.2833 14.978C18.2711 14.9654 18.1856 14.7326 18.0941 14.4621C18.0026 14.1979 17.9171 13.984 17.9049 13.9903C17.8988 14.0029 17.9171 14.2357 17.9476 14.5062C17.9843 14.783 17.9843 15.022 17.9598 15.0534C17.8744 15.1289 16.959 15.1667 16.5318 15.1038ZM18.1978 13.5374C19.1682 13.2292 19.6076 12.4932 19.4611 11.4363C19.4306 11.2036 19.3452 10.8702 19.278 10.7003C19.1255 10.3355 18.7288 9.93916 18.3931 9.81964C18.0514 9.69383 17.3679 9.72528 16.9407 9.88255L16.5867 10.0147L16.6233 9.81335C16.6416 9.70012 16.6844 9.58689 16.7088 9.56173C16.7393 9.53027 17.1482 9.41704 17.6303 9.30381C18.1063 9.19687 18.4969 9.08993 18.503 9.07106C18.503 9.05219 18.4847 8.7062 18.4603 8.3036L18.4175 7.56131H18.2223C17.8378 7.5676 16.7393 7.74373 16.3426 7.86955C15.5859 8.11488 15.0488 8.62442 14.8596 9.27236C14.6582 9.97691 14.8047 11.2728 15.2014 12.2478C15.4516 12.8832 15.9703 13.4556 16.4463 13.6192C16.843 13.7576 17.6303 13.7198 18.1978 13.5374Z"
                fill="white"
              />
              <path
                d="M17.2293 12.0152C17.1561 11.9774 17.0645 11.8705 17.0279 11.7761C16.8387 11.298 17.3331 10.9206 17.6321 11.3106C17.9372 11.7132 17.6443 12.2227 17.2293 12.0152Z"
                fill="white"
              />
              <path
                d="M65.2094 14.7389L65.0263 14.7012L65.008 13.7576L64.9958 12.8077L65.423 12.8329C65.6549 12.8455 65.9478 12.8392 66.0638 12.8203C66.3384 12.7637 66.674 12.4114 66.8754 11.9711L67.028 11.6314L66.7351 10.8387C66.5764 10.4047 66.3384 9.75047 66.2041 9.38561C66.0699 9.02075 65.8502 8.42943 65.7159 8.06458C65.5816 7.69972 65.4047 7.23421 65.3314 7.02662C64.7578 5.50429 64.4465 4.64247 64.4465 4.59844C64.4465 4.56699 64.9775 4.54182 65.6244 4.54182H66.7961L67.3637 6.60515C67.6749 7.73747 67.9617 8.84462 67.9983 9.07108L68.0716 9.47997L68.1265 9.19689C68.1814 8.93898 68.5842 7.41664 68.7246 6.96372C68.7551 6.86307 68.9077 6.32207 69.0602 5.7685C69.2128 5.21492 69.3532 4.71167 69.3654 4.65506C69.3959 4.55441 69.5057 4.54182 70.5493 4.54182H71.6966L71.4525 5.24638C71.3183 5.63639 71.0741 6.35353 70.9033 6.8379C70.7385 7.32228 70.5737 7.78779 70.5493 7.87586C70.5188 7.96393 70.415 8.27217 70.3174 8.56783C70.2137 8.86349 69.994 9.49884 69.8292 9.98322C69.6583 10.4676 69.3959 11.2288 69.2433 11.6817C68.5293 13.745 67.8946 14.4999 66.6801 14.7264C66.2896 14.8018 65.5145 14.8081 65.2094 14.7389Z"
                fill="white"
              />
              <path
                d="M33.3196 11.7759C31.922 11.5997 30.97 10.7316 30.6283 9.32251C30.5062 8.81297 30.5245 7.32838 30.6588 6.81255C30.9639 5.66136 31.5559 4.98198 32.5628 4.6297C32.9839 4.47873 33.1426 4.45985 33.7773 4.45985C34.412 4.45985 34.5768 4.48502 34.9917 4.6297C35.7912 4.90649 36.2428 5.30909 36.5602 6.01993C36.7982 6.52947 36.8714 6.99498 36.8836 7.93857L36.8897 8.7249L34.8819 8.74377C33.5149 8.75006 32.8558 8.78152 32.8253 8.82555C32.807 8.8633 32.8131 9.00798 32.8497 9.15267C32.929 9.48607 33.3257 9.89496 33.6613 10.0019C34.2472 10.178 35.3762 10.0459 36.1452 9.70624L36.432 9.58043V10.4485V11.3229L36.133 11.455C35.4861 11.7381 34.1984 11.8891 33.3196 11.7759ZM34.8453 7.17741C34.8453 7.14595 34.8148 6.98869 34.7782 6.844C34.6988 6.5106 34.412 6.21494 34.0885 6.12058C33.4966 5.95702 33.0144 6.31559 32.8619 7.0453L32.8192 7.2466H33.8322C34.5035 7.2466 34.8453 7.22144 34.8453 7.17741Z"
                fill="white"
              />
              <path
                d="M49.2194 11.801C48.7983 11.7696 48.2429 11.6626 47.8646 11.5431L47.5411 11.4362V10.4737C47.5411 9.94529 47.5533 9.51123 47.5655 9.51123C47.5777 9.51123 47.7669 9.58043 47.9866 9.6685C48.957 10.0459 50.0921 10.1592 50.446 9.92012C50.8061 9.68108 50.5559 9.36026 49.7076 8.98911C48.4626 8.44182 48.0293 8.11471 47.7486 7.5171C47.5289 7.06418 47.4862 6.40995 47.6326 5.89412C47.712 5.60475 47.8035 5.46006 48.0782 5.1707C48.3772 4.86875 48.4992 4.79326 48.9447 4.64228C49.4025 4.47873 49.5489 4.45985 50.2263 4.45985C51.0563 4.45985 51.5445 4.55421 52.2158 4.83729C52.4294 4.93165 52.6064 5.0323 52.6064 5.07005C52.6064 5.15811 52.1121 6.4414 52.0511 6.51689C52.0206 6.54834 51.8741 6.51689 51.6971 6.4414C51.5323 6.37221 51.154 6.25268 50.861 6.1772C50.0677 5.96961 49.61 6.08284 49.7015 6.45398C49.7442 6.63012 49.8724 6.71819 50.4704 6.98869C51.9046 7.64291 52.2952 7.92599 52.5515 8.5236C52.7407 8.97024 52.7529 9.88867 52.5759 10.3919C52.3562 11.0084 51.7459 11.5179 51.0197 11.7004C50.7085 11.7759 49.671 11.8325 49.2194 11.801Z"
                fill="white"
              />
              <path
                d="M55.3573 11.7761C54.8874 11.7006 54.3808 11.4175 54.1855 11.1155C53.8011 10.5116 53.8011 10.4739 53.7767 8.33508L53.7583 6.36612H53.3617H52.9711V5.86916V5.3722L53.4654 5.00105L53.9658 4.6299L54.2527 3.88132L54.5456 3.12644L55.284 3.10757L56.0225 3.0887V3.81841V4.54183H56.8464H57.6763L57.658 5.44139L57.6397 6.33466L56.828 6.35354L56.0164 6.37241L56.0347 7.97652L56.053 9.58692L56.2239 9.73789C56.4314 9.92032 56.7914 9.93919 57.3224 9.79451C57.5177 9.74418 57.6885 9.70015 57.7007 9.70015C57.7191 9.70015 57.7313 10.0902 57.7313 10.5745V11.4427L57.4749 11.5433C56.8708 11.7761 55.9737 11.8704 55.3573 11.7761Z"
                fill="white"
              />
              <path
                d="M59.5335 11.7823C58.9049 11.669 58.3923 11.235 58.1482 10.587C58.0444 10.3103 58.0139 10.0964 58.0139 9.57425C58.0078 8.94519 58.02 8.88857 58.2092 8.49226C58.3618 8.17144 58.4777 8.02046 58.728 7.83804C59.3138 7.40398 60.217 7.18381 61.4193 7.18381H61.9624L61.9319 6.86928C61.8587 6.08295 61.1447 5.93197 59.8692 6.43522C59.619 6.53587 59.381 6.61765 59.3443 6.61765C59.2406 6.61765 58.6486 5.12048 58.7341 5.05129C58.85 4.95693 59.3993 4.73675 59.7776 4.6361C59.979 4.58578 60.4673 4.51029 60.87 4.47255C62.3652 4.32786 63.3356 4.68014 63.8787 5.56712C64.1777 6.05779 64.2022 6.3157 64.2022 9.11503V11.7131H63.4393H62.6704L62.4507 11.2413C62.3347 10.9834 62.2188 10.7695 62.2065 10.7695C62.1882 10.7695 61.9991 10.9393 61.7855 11.1406C61.5413 11.3797 61.2911 11.5558 61.0775 11.6376C60.7175 11.7697 59.9119 11.8515 59.5335 11.7823ZM61.4864 9.95798C61.816 9.76297 61.9441 9.49247 61.9441 8.95777V8.48597L61.4742 8.51742C60.9128 8.54888 60.571 8.69985 60.4123 8.97035C60.217 9.29746 60.2781 9.81958 60.5344 9.98314C60.7907 10.1467 61.1691 10.1404 61.4864 9.95798Z"
                fill="white"
              />
              <path
                d="M25.7644 8.14643L25.7827 4.57335L26.6187 4.55448L27.4548 4.53561L27.6196 5.08918C27.7844 5.65534 27.8759 5.83777 27.9308 5.68679C27.9492 5.63647 28.0956 5.44146 28.2543 5.24016C28.4618 4.98853 28.6571 4.82497 28.9561 4.66771C29.3406 4.46641 29.4138 4.44754 29.8837 4.45383C30.1645 4.46012 30.4086 4.4727 30.4208 4.48528C30.4269 4.49786 30.3964 5.01998 30.3475 5.64276L30.2499 6.77507H29.5725C28.7425 6.77507 28.5045 6.87572 28.2238 7.34123L28.0407 7.64318L28.0224 9.68134L27.998 11.7132H26.8751H25.7522L25.7644 8.14643Z"
                fill="white"
              />
              <path
                d="M39.3034 11.5747C39.1814 11.2728 36.8623 4.64877 36.8623 4.59215C36.8623 4.56699 37.3811 4.54811 38.028 4.55441L39.1936 4.57328L39.7673 6.73096C40.0785 7.9136 40.3592 9.03333 40.3836 9.21576L40.4264 9.54288L40.5057 9.16544C40.6155 8.69364 41.6652 4.87523 41.7446 4.68651C41.7995 4.54182 41.8178 4.54182 42.9407 4.54182H44.0758L44.0453 4.68651C44.0331 4.762 43.9294 5.06395 43.8195 5.35961C43.7158 5.65527 43.6059 5.96351 43.5754 6.05158C43.5449 6.13964 43.435 6.44789 43.3313 6.74355C43.2275 7.0392 43.1177 7.34745 43.0872 7.43551C43.0567 7.52358 42.9468 7.83182 42.8431 8.12748C42.7393 8.42314 42.6234 8.73138 42.599 8.81945C42.5501 8.97043 42.5013 9.10882 42.1107 10.2034C42.007 10.4991 41.8483 10.9583 41.7568 11.2288L41.5981 11.7131H40.4813C39.3767 11.7131 39.3584 11.7131 39.3034 11.5747Z"
                fill="white"
              />
              <path
                d="M44.3659 8.12748V4.54182L45.4827 4.55441L46.5935 4.57328L46.6118 8.14636L46.624 11.7131H45.495H44.3659V8.12748Z"
                fill="white"
              />
              <path
                d="M22.006 11.4174C22.0304 11.2853 22.0548 10.8576 22.0548 10.4675L22.0609 9.76299L22.2379 9.63717C22.7993 9.25974 22.7505 8.26582 22.1585 7.97016C22.0365 7.91354 21.7863 7.84434 21.6032 7.83176C21.2858 7.80031 21.2553 7.78144 21.0539 7.48578C20.6145 6.84413 19.6198 6.09555 18.8142 5.79989L18.4297 5.6552V4.05738V2.45956L20.2178 2.47215C22.6223 2.47844 23.3181 2.59167 24.0321 3.08234C24.801 3.60446 25.0573 4.86259 24.5874 5.82505C24.4166 6.18362 24.0199 6.57364 23.7147 6.68687C23.5927 6.7309 23.5011 6.79381 23.5133 6.82526C23.5194 6.85672 23.6476 6.9322 23.788 6.98882C24.6912 7.34738 25.0757 8.14 24.9475 9.39184C24.8926 9.94542 24.7034 10.348 24.2884 10.7758C23.7819 11.3042 22.9763 11.6502 22.2623 11.6502H21.9571L22.006 11.4174ZM21.7801 5.98232C22.2195 5.88796 22.4576 5.59859 22.4576 5.16454C22.4576 4.56063 22.1463 4.35304 21.237 4.35304H20.6877V5.15824C20.6877 5.60488 20.7061 5.98861 20.7305 6.00748C20.7915 6.07668 21.4445 6.05781 21.7801 5.98232Z"
                fill="white"
              />
              <path
                d="M45.0989 3.79337C44.5497 3.68013 44.3055 3.35302 44.3055 2.74912C44.3055 1.98795 44.629 1.71117 45.5078 1.71117C45.9777 1.71117 46.0876 1.73004 46.2645 1.85585C46.5758 2.06973 46.6978 2.3591 46.6734 2.82461C46.649 3.27753 46.5148 3.51029 46.1913 3.67384C45.9411 3.79966 45.3979 3.85627 45.0989 3.79337Z"
                fill="white"
              />
              <path
                d="M1.90106 20.149H1.79062V20.2594V27.9967V28.1071H1.90106H5.42732H5.53776V27.9967V27.0609V26.9504H5.42732H3.08422V24.6721H5.10779H5.21823V24.5617V23.6145V23.5041H5.10779H3.08422V21.3171H5.42732H5.53776V21.2066V20.2594V20.149H5.42732H1.90106ZM22.7197 20.149H22.6446L22.617 20.2187L21.6464 22.6659L20.6653 20.2183L20.6375 20.149H20.5628H19.3988H19.2312L19.2973 20.303L20.9447 24.1393L19.2974 27.9529L19.2308 28.1071H19.3988H20.5628H20.6373L20.6652 28.0381L21.6458 25.6122L22.6055 28.0373L22.6332 28.1071H22.7082H23.8837H24.0526L23.9848 27.9524L22.3152 24.1393L23.9849 20.3035L24.0522 20.149H23.8837H22.7197ZM41.6946 20.2594V20.149H41.5841H37.5558H37.4453V20.2594V21.2066V21.3171H37.5558H38.9174V27.9967V28.1071H39.0279H40.112H40.2225V27.9967V21.3171H41.5841H41.6946V21.2066V20.2594ZM58.9717 24.9078C59.2658 24.7762 59.4941 24.5781 59.6517 24.3129C59.8264 24.019 59.9098 23.6508 59.9098 23.2151V21.9826C59.9098 21.419 59.7382 20.9649 59.3843 20.6355C59.0375 20.3055 58.5422 20.149 57.9164 20.149H55.8394H55.729V20.2594V27.9967V28.1071H55.8394H56.9121H57.0226V27.9967V25.0944H57.6909L58.7713 28.0347L58.7979 28.1071H58.875H60.0618H60.2236L60.1646 27.9564L58.9717 24.9078ZM58.4317 23.7875L58.4296 23.7896C58.3232 23.9019 58.132 23.972 57.8251 23.972H57.0226V21.3056H57.8251C58.1099 21.3056 58.3031 21.3734 58.4252 21.4893C58.5462 21.6042 58.6162 21.7843 58.6162 22.0511V23.2037C58.6162 23.4843 58.5477 23.6714 58.4317 23.7875ZM77.7431 28.0189L77.7613 28.1071H77.8513H78.9012H79.038L79.0092 27.9734L77.3431 20.2362L77.3243 20.149H77.2351H75.7287H75.6398L75.6208 20.2359L73.9319 27.9731L73.9026 28.1071H74.0398H75.0897H75.1797L75.1978 28.0189L75.602 26.053H77.339L77.7431 28.0189ZM96.5682 20.149H96.4577V20.2594L96.4577 23.5575L96.4577 23.5589C96.4654 24.1239 96.4883 24.7115 96.5264 25.3218L96.5265 25.3232C96.5323 25.3993 96.5377 25.4709 96.5427 25.5383C96.5059 25.4352 96.4654 25.3218 96.4211 25.1978C96.1921 24.5567 95.5485 22.8961 94.4912 20.2189L94.4636 20.149H94.3885H93.2359H93.1255V20.2594V27.9967V28.1071H93.2359H94.2858H94.3963V27.9967V24.653C94.3963 23.9564 94.3736 23.3129 94.3283 22.7225C94.7545 23.8513 95.4404 25.623 96.3855 28.0369L96.4129 28.1071H96.4883H97.6295H97.7399V27.9967V20.2594V20.149H97.6295H96.5682ZM112.508 20.149H112.398V20.2594V27.9967V28.1071H112.508H116.034H116.145V27.9967V27.0609V26.9504H116.034H113.691V24.6721H115.715H115.825V24.5617V23.6145V23.5041H115.715H113.691V21.3171H116.034H116.145V21.2066V20.2594V20.149H116.034H112.508ZM134.11 20.2594V20.149H134H129.972H129.861V20.2594V21.2066V21.3171H129.972H131.333V27.9967V28.1071H131.444H132.528H132.638V27.9967V21.3171H134H134.11V21.2066V20.2594ZM77.0995 24.9077H75.8297L76.4599 21.8132L77.0995 24.9077Z"
                fill="white"
                stroke="white"
                stroke-width="0.220881"
              />
              <path
                d="M78.6657 -4.57764e-05L78.6657 15.8463"
                stroke="white"
                stroke-width="1.04214"
              />
              <path
                d="M89.2604 7.52102V12.4505H86.5087V0.925895H89.1704V5.39392H89.266C89.4611 4.86121 89.78 4.44479 90.2227 4.14467C90.6691 3.84456 91.2149 3.6945 91.8602 3.6945C92.4679 3.6945 92.9969 3.82955 93.4471 4.09966C93.8973 4.36601 94.2461 4.74304 94.4937 5.23073C94.7451 5.71843 94.8689 6.28865 94.8651 6.94141V12.4505H92.1134V7.48163C92.1172 7.00144 91.9971 6.62629 91.7533 6.35618C91.5094 6.08607 91.1662 5.95102 90.7235 5.95102C90.4346 5.95102 90.1795 6.01479 89.9582 6.14234C89.7406 6.26614 89.5699 6.44434 89.4461 6.67693C89.3261 6.90952 89.2642 7.19089 89.2604 7.52102Z"
                fill="white"
              />
              <path
                d="M100.618 12.6137C99.7097 12.6137 98.9294 12.428 98.2767 12.0566C97.6276 11.6814 97.1268 11.16 96.7742 10.4922C96.4253 9.82068 96.2508 9.04225 96.2508 8.1569C96.2508 7.26779 96.4253 6.48936 96.7742 5.82159C97.1268 5.15007 97.6276 4.62862 98.2767 4.25722C98.9294 3.88207 99.7097 3.6945 100.618 3.6945C101.525 3.6945 102.304 3.88207 102.953 4.25722C103.606 4.62862 104.106 5.15007 104.455 5.82159C104.808 6.48936 104.984 7.26779 104.984 8.1569C104.984 9.04225 104.808 9.82068 104.455 10.4922C104.106 11.16 103.606 11.6814 102.953 12.0566C102.304 12.428 101.525 12.6137 100.618 12.6137ZM100.634 10.5372C100.965 10.5372 101.244 10.4359 101.473 10.2333C101.702 10.0308 101.876 9.7494 101.996 9.38926C102.12 9.02912 102.182 8.6127 102.182 8.14001C102.182 7.65982 102.12 7.23966 101.996 6.87951C101.876 6.51937 101.702 6.23801 101.473 6.03543C101.244 5.83285 100.965 5.73156 100.634 5.73156C100.293 5.73156 100.004 5.83285 99.7679 6.03543C99.5353 6.23801 99.3571 6.51937 99.2333 6.87951C99.1132 7.23966 99.0532 7.65982 99.0532 8.14001C99.0532 8.6127 99.1132 9.02912 99.2333 9.38926C99.3571 9.7494 99.5353 10.0308 99.7679 10.2333C100.004 10.4359 100.293 10.5372 100.634 10.5372Z"
                fill="white"
              />
              <path
                d="M109.146 0.925895V12.4505H106.394V0.925895H109.146Z"
                fill="white"
              />
              <path
                d="M110.897 12.4505V3.80704H113.649V12.4505H110.897ZM112.276 2.79977C111.889 2.79977 111.557 2.67221 111.28 2.41711C111.002 2.15826 110.863 1.84689 110.863 1.48299C110.863 1.12285 111.002 0.815225 111.28 0.560124C111.557 0.301271 111.889 0.171844 112.276 0.171844C112.666 0.171844 112.998 0.301271 113.272 0.560124C113.549 0.815225 113.688 1.12285 113.688 1.48299C113.688 1.84689 113.549 2.15826 113.272 2.41711C112.998 2.67221 112.666 2.79977 112.276 2.79977Z"
                fill="white"
              />
              <path
                d="M118.557 12.5743C117.919 12.5743 117.34 12.4092 116.818 12.0791C116.297 11.749 115.881 11.2538 115.569 10.5935C115.258 9.93323 115.102 9.11353 115.102 8.13439C115.102 7.11773 115.263 6.28115 115.586 5.62464C115.909 4.96813 116.331 4.48231 116.852 4.16718C117.377 3.85206 117.942 3.6945 118.546 3.6945C119 3.6945 119.388 3.77328 119.711 3.93084C120.033 4.08465 120.3 4.28348 120.51 4.52733C120.72 4.77117 120.879 5.0244 120.988 5.287H121.044V0.925895H123.796V12.4505H121.073V11.0493H120.988C120.872 11.3157 120.707 11.5651 120.493 11.7977C120.279 12.0303 120.011 12.2179 119.688 12.3604C119.369 12.503 118.992 12.5743 118.557 12.5743ZM119.514 10.4303C119.848 10.4303 120.133 10.3365 120.369 10.1489C120.606 9.95761 120.787 9.68938 120.915 9.34424C121.043 8.99911 121.106 8.59394 121.106 8.12876C121.106 7.65607 121.043 7.24903 120.915 6.90765C120.791 6.56626 120.609 6.30366 120.369 6.11984C120.133 5.93601 119.848 5.8441 119.514 5.8441C119.172 5.8441 118.884 5.93789 118.647 6.12546C118.411 6.31304 118.231 6.57752 118.107 6.9189C117.987 7.26029 117.927 7.66357 117.927 8.12876C117.927 8.59394 117.989 8.99911 118.113 9.34424C118.236 9.68938 118.415 9.95761 118.647 10.1489C118.884 10.3365 119.172 10.4303 119.514 10.4303Z"
                fill="white"
              />
              <path
                d="M127.973 12.5968C127.422 12.5968 126.932 12.5049 126.504 12.3211C126.08 12.1335 125.745 11.8521 125.497 11.477C125.253 11.0981 125.131 10.6235 125.131 10.0533C125.131 9.57308 125.216 9.16792 125.384 8.83779C125.553 8.50766 125.786 8.23943 126.082 8.0331C126.379 7.82676 126.72 7.67108 127.106 7.56604C127.493 7.45724 127.905 7.38409 128.344 7.34657C128.836 7.30156 129.232 7.25466 129.532 7.20589C129.832 7.15337 130.049 7.08022 130.185 6.98643C130.323 6.88889 130.393 6.75196 130.393 6.57564V6.54751C130.393 6.25864 130.293 6.03543 130.094 5.87786C129.896 5.7203 129.627 5.64152 129.29 5.64152C128.926 5.64152 128.633 5.7203 128.412 5.87786C128.191 6.03543 128.05 6.25301 127.99 6.53062L125.452 6.44059C125.527 5.91538 125.72 5.44644 126.032 5.03378C126.347 4.61736 126.778 4.29098 127.326 4.05464C127.877 3.81454 128.539 3.6945 129.312 3.6945C129.864 3.6945 130.372 3.76015 130.837 3.89145C131.302 4.019 131.708 4.20657 132.053 4.45417C132.398 4.69802 132.664 4.99814 132.852 5.35453C133.043 5.71092 133.139 6.11796 133.139 6.57564V12.4505H130.55V11.2463H130.483C130.329 11.5389 130.132 11.7865 129.892 11.989C129.656 12.1916 129.376 12.3436 129.053 12.4449C128.735 12.5461 128.374 12.5968 127.973 12.5968ZM128.823 10.7961C129.119 10.7961 129.385 10.736 129.622 10.616C129.862 10.496 130.053 10.3309 130.196 10.1208C130.338 9.90697 130.41 9.65937 130.41 9.37801V8.55643C130.331 8.5977 130.235 8.63521 130.123 8.66897C130.014 8.70274 129.894 8.73463 129.762 8.76464C129.631 8.79465 129.496 8.82091 129.357 8.84342C129.218 8.86593 129.085 8.88656 128.958 8.90532C128.699 8.94658 128.478 9.01036 128.294 9.09664C128.114 9.18293 127.975 9.29547 127.877 9.43428C127.784 9.56933 127.737 9.73065 127.737 9.91822C127.737 10.2033 127.838 10.4209 128.041 10.571C128.247 10.721 128.508 10.7961 128.823 10.7961Z"
                fill="white"
              />
            </svg>
          </div>
        ) : null}
        {/* isMobile ?
              (
                <div
                  style={{
                    backgroundColor: "#5F1CCC",

                    width: "100vw",
                    maxHeight: "14vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    paddingTop: 25,
                    paddingLeft: 20,
                    paddingBottom: 20,
                  }}
                >
                  <Image
                    src="https://s3.ap-south-1.amazonaws.com/site-img-res-new/logo-mail.png"
                    wrapped
                    style={{
                      width: "50%",
                    }}
                  />
                </div>
              ) : null */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    session: state.session.response,
    hideHeader: state.commonActionsReducer.hideHeader,
  };
};
export default connect(mapStateToProps)(withRouter(Header));
